import * as React from "react";
import { useRouter } from "next/router";
import { useMachine } from "@xstate/react";
import { IOfferMode } from "@nju/data-access-portal-offers";
import { ErrorMessage } from "@nju/form";
import { salesRoutes } from "@nju/routes";
import { BlockText, Button, ButtonsWrapper, Separator } from "@nju/ui";
import { cancelOrderMachine } from "./cancelOrder.machine";

type ICancelOrderModal =
  | {
      orchestratorId: string;
      onClose: () => void;
      redirect?: string;
      mode?: IOfferMode;
    }
  | {
      orchestratorId: undefined;
      skipCancellation: true;
      mode?: IOfferMode;
      onClose: () => void;
    };

function getParams(params: ICancelOrderModal) {
  if (params.orchestratorId) {
    return {
      orchestratorId: params.orchestratorId,
    };
  }

  if (!params.orchestratorId) {
    return {
      skipCancellation: true,
    };
  }

  throw new Error("invalid orchestrator type");
}

export function CancelOrderModal(props: ICancelOrderModal) {
  const router = useRouter();
  const { mode = "ftth", onClose } = props;

  const [current, send] = useMachine(cancelOrderMachine, {
    actions: {
      cancelOrderSuccess: () => {
        router.push(salesRoutes.panel.get());
      },
    },
    context: {
      ...getParams(props),
      mode,
    },
  });

  const { context } = current;
  const { error } = context;

  const handleConfirm = React.useCallback(() => {
    send({ type: "SUBMIT" });
  }, [send]);

  return (
    <>
      <BlockText
        size={{
          "@onlyMobile": "s",
          "@fromTablet": "l",
        }}
      >
        <BlockText
          size={{
            "@onlyMobile": "s",
            "@fromTablet": "l",
          }}
        >
          Jeśli teraz anulujesz zamówienie, wrócisz do panelu konsultanta.
        </BlockText>{" "}
        Przy ponownej próbie zakupu możesz przywrócić dane klienta (m.in. imię i
        nazwisko), wpisując jego adres e-mail.
      </BlockText>
      <Separator size="xxs" tone="invisible" />
      {error && <ErrorMessage message={error} />}
      <ButtonsWrapper withSeparator={false}>
        <Button
          onPress={onClose}
          size={{ "@onlyMobile": "s" }}
          variant="secondary"
        >
          powrót
        </Button>
        <Button
          data-cy="order-cancellation-confirmation-button"
          isLoading={current.matches("send")}
          onPress={handleConfirm}
          size={{ "@onlyMobile": "s" }}
        >
          anuluj zamówienie
        </Button>
      </ButtonsWrapper>
    </>
  );
}
